import React, { useState, useEffect, useRef } from 'react'
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import _ from 'lodash';
import { Accordion, AccordionTab } from 'primereact/accordion';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import DataTable from '../../../../Components/UiComponents/DataTable';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import { loadFor } from '../../../../Services/checklistService';
import { findSaved, saveBidteam } from '../../../../Services/bidteamService';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement';
import { loadFor as loadForTool } from '../../../../Services/toolService';
import { useOpportunity } from '../../../../Providers/OpportunityContext';
import { useNavigate } from 'react-router-dom';

const PromptsAndChecklists = (props) => {
	const [newModule, setNewModule] = useState({});
	const [loading, setLoading] = useState(false);
	const [opportunityData, setOpportunityData] = useState({});
	const [selectedOption, setSelectedOption] = useState([]);
	const [winChecklist, setWinChecklist] = useState([]);
	const [winTools, setWinTools] = useState([]);
	const [isStop, setIsStop] = useState(false);
	const navigate = useNavigate()
	const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();

	const enduser = localStorage.getItem("enduser");
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
			navigate("/login")
			localStorage.clear()
		}
	}

	const userId = tmpData.userid;
	const curCustomer = tmpData.customer;
	const role = tmpData.role;

	const toastRef = useRef();

	useEffect(() => {
		if (props.fieldData.pipelineWinningSections) {
			let obj1 = _.find(props?.fieldData?.pipelineWinningSections, { section_name: "Checklist" })?.display_name;
			let obj2 = _.find(props?.fieldData?.pipelineWinningSections, { section_name: "Responsibilities" })?.display_name;
			let obj3 = _.find(props?.fieldData?.pipelineWinningSections, { section_name: "Ways of Winning Prompts" })?.display_name;
			let obj4 = _.find(props?.fieldData?.pipelineWinningSections, { section_name: "Document Reference" })?.display_name;
			let combined = { obj1, obj2, obj3, obj4 };
			setNewModule(combined)
		}
	}, [props.fieldData.pipelineWinningSections])

	useEffect(() => {
		if (props.opportunityData) {
			setOpportunityData(props.opportunityData)
			winningLoad(props.opportunityData)
		}
	}, [props.opportunityData])

	useEffect(() => {
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			ways_winning: {
				...prevData.ways_winning,
				completed_list: opportunityData.ways_winning?.completed_list
			}
		}));
	}, [opportunityData.ways_winning]);

	const winningLoad = async (opportunityDetails) => {
		try {
			var pendingResponsibilities = []

			var bid_status = opportunityDetails.bid_status;
			if (bid_status == "Stop") {
				setIsStop(true);
			} else {
				setIsStop(false);
			}

			var wowAccess = false;
			var bidTeam = opportunityDetails.ie_bid_team?.internal_bid_team;

			const userprivileges = localStorage.getItem("user_privileges");
			if (userprivileges) {
				var user_privileges = JSON.parse(userprivileges);
				if (user_privileges !== undefined && user_privileges !== null) {
					var checklist_prompts_access = user_privileges[0].checklist_prompts_access;
				}
				if (checklist_prompts_access) {
					wowAccess = true;
				} else {
					for (var x = 0; x < bidTeam.length; x++) {
						if (bidTeam[x].user_id == userId) {
							wowAccess = true;
						}
					}
				}
			}

			var checkdata = await loadFor(curCustomer, opportunityDetails.winwork_stage, "Ways of Working", opportunityDetails.sector)

			if (checkdata && checkdata.data.length > 0) {


				var findUserBidRole = _.find(bidTeam, { user_id: userId });
				var bidTeamRole = findUserBidRole?.bid_team_role;

				var result = await findSaved(curCustomer, bidTeamRole, opportunityDetails._id, opportunityDetails.winwork_stage)
				var data = result.data.data;
				var winChecklist = [];

				if (wowAccess == true) {
					if (data) {
						if (data.ways_of_winning.checklist.length > 0) {
							if (result?.data.bid_team_role == bidTeamRole) {
								for (var i = 0; i < checkdata.data.length; i++) {
									var informed_users = checkdata.data[i].informed_users;
									var contributing_users = checkdata.data[i].contributing_users;
									var accountable_users = checkdata.data[i].accountable_users;
									var responsible_users = checkdata.data[i].responsible_users;
									for (var j = 0; j < informed_users.length; j++) {
										if (bidTeamRole == informed_users[j].role) {
											var status = false;
											for (var y = 0; y < data.ways_of_winning.checklist.length; y++) {
												if (data.ways_of_winning.checklist[y].check == checkdata.data[i].checklist_item + " (I)" && data.ways_of_winning.checklist[y].status) {
													status = true;
													break;
												}
											}
											winChecklist.push({
												check: checkdata.data[i].checklist_item + " (I)",
												status: status,
											});
										}
									}
									for (var j = 0; j < contributing_users.length; j++) {
										if (bidTeamRole == contributing_users[j].role) {
											var status = false;
											for (var y = 0; y < data.ways_of_winning.checklist.length; y++) {
												if (data.ways_of_winning.checklist[y].check == checkdata.data[i].checklist_item + " (C)" && data.ways_of_winning.checklist[y].status) {
													status = true;
													break;
												}
											}
											winChecklist.push({
												check: checkdata.data[i].checklist_item + " (C)",
												status: status,
											});
										}
									}
									if (accountable_users != null) {
										if (bidTeamRole == accountable_users.role) {
											var status = false;
											for (var y = 0; y < data.ways_of_winning.checklist.length; y++) {
												if (data.ways_of_winning.checklist[y].check == checkdata.data[i].checklist_item + " (A)" && data.ways_of_winning.checklist[y].status) {
													status = true;
													break;
												}
											}
											winChecklist.push({
												check: checkdata.data[i].checklist_item + " (A)",
												status: status,
											});
										}
									}
									for (var j = 0; j < responsible_users.length; j++) {
										if (bidTeamRole == responsible_users[j].role) {
											var status = false;
											for (var y = 0; y < data.ways_of_winning.checklist.length; y++) {
												if (data.ways_of_winning.checklist[y].check == checkdata.data[i].checklist_item + " (R)" && data.ways_of_winning.checklist[y].status) {
													status = true;
													break;
												}
											}
											winChecklist.push({
												check: checkdata.data[i].checklist_item + " (R)",
												status: status,
											});
										}
									}
								}
							}
						} else {
							if (result?.data.bid_team_role == bidTeamRole) {
								for (var i = 0; i < checkdata.data.length; i++) {
									var informed_users = checkdata.data[i].informed_users;
									var contributing_users = checkdata.data[i].contributing_users;
									var accountable_users = checkdata.data[i].accountable_users;
									var responsible_users = checkdata.data[i].responsible_users;

									for (var j = 0; j < informed_users.length; j++) {
										if (bidTeamRole == informed_users[j].role) {
											winChecklist.push({
												check: checkdata.data[i].checklist_item + " (I)",
												status: false,
											});
										}
									}

									for (var j = 0; j < contributing_users.length; j++) {
										if (bidTeamRole == contributing_users[j].role) {
											winChecklist.push({
												check: checkdata.data[i].checklist_item + " (C)",
												status: false,
											});
										}
									}
									if (accountable_users != null) {
										if (bidTeamRole == accountable_users.role) {
											winChecklist.push({
												check: checkdata.data[i].checklist_item + " (A)",
												status: false,
											});
										}
									}
									for (var j = 0; j < responsible_users.length; j++) {
										if (bidTeamRole == responsible_users[j].role) {
											winChecklist.push({
												check: checkdata.data[i].checklist_item + " (R)",
												status: false,
											});
										}
									}
								}
							}
						}
					} else {
						for (var i = 0; i < checkdata.data.length; i++) {
							var informed_users = checkdata.data[i].informed_users;
							var contributing_users = checkdata.data[i].contributing_users;
							var accountable_users = checkdata.data[i].accountable_users;
							var responsible_users = checkdata.data[i].responsible_users;

							for (var j = 0; j < informed_users.length; j++) {
								if (bidTeamRole == informed_users[j].role) {
									winChecklist.push({
										check: checkdata.data[i].checklist_item + " (I)",
										status: false,
									});
								}
							}

							for (var j = 0; j < contributing_users.length; j++) {
								if (bidTeamRole == contributing_users[j].role) {
									winChecklist.push({
										check: checkdata.data[i].checklist_item + " (C)",
										status: false,
									});
								}
							}
							if (accountable_users != null) {
								if (bidTeamRole == accountable_users.role) {
									winChecklist.push({
										check: checkdata.data[i].checklist_item + " (A)",
										status: false,
									});
								}
							}

							for (var j = 0; j < responsible_users.length; j++) {
								if (bidTeamRole == responsible_users[j].role) {
									winChecklist.push({
										check: checkdata.data[i].checklist_item + " (R)",
										status: false,
									});
								}
							}
						}
					}
				}
				setWinChecklist(winChecklist)


			}

			var toolData = await loadForTool(curCustomer, opportunityDetails.winwork_stage, "Ways of Working", opportunityDetails.sector)

			if (toolData.data.length > 0) {
				var findUserBidRole = _.find(bidTeam, { user_id: userId });
				var bidTeamRole = findUserBidRole?.bid_team_role;

				var result = await findSaved(curCustomer, bidTeamRole, opportunityDetails._id, opportunityDetails.winwork_stage)
				var data = result.data.data;
				var winTools = [];

				if (wowAccess == true) {
					if (data && data.ways_of_winning.responsibility) {
						if (data.ways_of_winning.responsibility.length > 0) {
							if (result?.data.bid_team_role == bidTeamRole) {
								for (var i = 0; i < toolData.data.length; i++) {
									var informed_users = toolData.data[i].informed_users;
									var contributing_users = toolData.data[i].contributing_users;
									var accountable_users = toolData.data[i].accountable_users;
									var responsible_users = toolData.data[i].responsible_users;
									for (var j = 0; j < informed_users.length; j++) {
										if (bidTeamRole == informed_users[j].role) {
											var status = false;
											for (var y = 0; y < data.ways_of_winning.responsibility.length; y++) {
												if (data.ways_of_winning.responsibility[y].check == toolData.data[i].display_name + " (I)" && data.ways_of_winning.responsibility[y].status) {
													status = true;
													break;
												}
											}
											winTools.push({
												check: toolData.data[i].display_name + " (I)",
												status: status,
												url: toolData.data[i].url,
											});
											if (status != true)
												pendingResponsibilities.push({
													resp: toolData.data[i].display_name + " (I)",
												});
										}
									}
									for (var j = 0; j < contributing_users.length; j++) {
										if (bidTeamRole == contributing_users[j].role) {
											var status = false;
											for (var y = 0; y < data.ways_of_winning.responsibility.length; y++) {
												if (data.ways_of_winning.responsibility[y].check == toolData.data[i].display_name + " (C)" && data.ways_of_winning.responsibility[y].status) {
													status = true;
													break;
												}
											}
											winTools.push({
												check: toolData.data[i].display_name + " (C)",
												status: status,
												url: toolData.data[i].url,
											});
											if (status != true)
												pendingResponsibilities.push({
													resp: toolData.data[i].display_name + " (C)",
												});
										}
									}
									if (accountable_users != null) {
										if (bidTeamRole == accountable_users.role) {
											var status = false;
											for (var y = 0; y < data.ways_of_winning.responsibility.length; y++) {
												if (data.ways_of_winning.responsibility[y].check == toolData.data[i].display_name + " (A)" && data.ways_of_winning.responsibility[y].status) {
													status = true;
													break;
												}
											}
											winTools.push({
												check: toolData.data[i].display_name + " (A)",
												status: status,
												url: toolData.data[i].url,
											});
											if (status != true)
												pendingResponsibilities.push({
													resp: toolData.data[i].display_name + " (A)",
												});
										}
									}
									for (var j = 0; j < responsible_users.length; j++) {
										if (bidTeamRole == responsible_users[j].role) {
											var status = false;
											for (var y = 0; y < data.ways_of_winning.responsibility.length; y++) {
												if (data.ways_of_winning.responsibility[y].check == toolData.data[i].display_name + " (R)" && data.ways_of_winning.responsibility[y].status) {
													status = true;
													break;
												}
											}
											winTools.push({
												check: toolData.data[i].display_name + " (R)",
												status: status,
												url: toolData.data[i].url,
											});
											if (status != true)
												pendingResponsibilities.push({
													resp: toolData.data[i].display_name + " (R)",
												});
										}
									}
								}
							}
						} else {
							if (result?.data.bid_team_role == bidTeamRole) {
								for (var i = 0; i < toolData.data.length; i++) {
									var informed_users = toolData.data[i].informed_users;
									var contributing_users = toolData.data[i].contributing_users;
									var accountable_users = toolData.data[i].accountable_users;
									var responsible_users = toolData.data[i].responsible_users;

									for (var j = 0; j < informed_users.length; j++) {
										if (bidTeamRole == informed_users[j].role) {
											winTools.push({
												check: toolData.data[i].display_name + " (I)",
												status: false,
												url: toolData.data[i].url,
											});
											pendingResponsibilities.push({
												resp: toolData.data[i].display_name + " (I)",
											});
										}
									}

									for (var j = 0; j < contributing_users.length; j++) {
										if (bidTeamRole == contributing_users[j].role) {
											winTools.push({
												check: toolData.data[i].display_name + " (C)",
												status: false,
												url: toolData.data[i].url,
											});
											pendingResponsibilities.push({
												resp: toolData.data[i].display_name + " (C)",
											});
										}
									}
									if (accountable_users != null) {
										if (bidTeamRole == accountable_users.role) {
											winTools.push({
												check: toolData.data[i].display_name + " (A)",
												status: false,
												url: toolData.data[i].url,
											});
											pendingResponsibilities.push({
												resp: toolData.data[i].display_name + " (A)",
											});
										}
									}
									for (var j = 0; j < responsible_users.length; j++) {
										if (bidTeamRole == responsible_users[j].role) {
											winTools.push({
												check: toolData.data[i].display_name + " (R)",
												status: false,
												url: toolData.data[i].url,
											});
											pendingResponsibilities.push({
												resp: toolData.data[i].display_name + " (R)",
											});
										}
									}
								}
							}
						}
					} else {
						for (var i = 0; i < toolData.data.length; i++) {
							var informed_users = toolData.data[i].informed_users;
							var contributing_users = toolData.data[i].contributing_users;
							var accountable_users = toolData.data[i].accountable_users;
							var responsible_users = toolData.data[i].responsible_users;

							for (var j = 0; j < informed_users.length; j++) {
								if (bidTeamRole == informed_users[j].role) {
									winTools.push({
										check: toolData.data[i].display_name + " (I)",
										status: false,
										url: toolData.data[i].url,
									});
									pendingResponsibilities.push({
										resp: toolData.data[i].display_name + " (I)",
									});
								}
							}

							for (var j = 0; j < contributing_users.length; j++) {
								if (bidTeamRole == contributing_users[j].role) {
									winTools.push({
										check: toolData.data[i].display_name + " (C)",
										status: false,
										url: toolData.data[i].url,
									});
									pendingResponsibilities.push({
										resp: toolData.data[i].display_name + " (C)",
									});
								}
							}
							if (accountable_users != null) {
								if (bidTeamRole == accountable_users.role) {
									winTools.push({
										check: toolData.data[i].display_name + " (A)",
										status: false,
										url: toolData.data[i].url,
									});
									pendingResponsibilities.push({
										resp: toolData.data[i].display_name + " (A)",
									});
								}
							}

							for (var j = 0; j < responsible_users.length; j++) {
								if (bidTeamRole == responsible_users[j].role) {
									winTools.push({
										check: toolData.data[i].display_name + " (R)",
										status: false,
										url: toolData.data[i].url,
									});
									pendingResponsibilities.push({
										resp: toolData.data[i].display_name + " (R)",
									});
								}
							}
						}
					}
				}
				// if (data != null) {
				// 	setOpportunityData((prevState) => ({
				// 		...prevState,
				// 		ways_winning: {
				// 			...prevState.ways_winning,
				// 			completed_list: data.ways_of_winning.reference
				// 		},
				// 	}));
				// }

				setWinTools(winTools)
			}
			props.pendingResponsibility(pendingResponsibilities)
		} catch (error) {
			// Handle any errors that occurred during the API calls
			toastRef?.current?.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or contact Admin.'
			});
		}
	}

	const wow_check_change = async (e, index, field) => {
		try {
			var findUserBidRole = _.find(opportunityData.ie_bid_team.internal_bid_team, { user_id: userId });

			if (!_.isEmpty(findUserBidRole) && !_.isEmpty(findUserBidRole?.bid_team_role)) {
				var wowChanges = {};
				wowChanges.opportunity_id = opportunityData._id;
				wowChanges.customer_id = curCustomer;
				wowChanges.winstage = opportunityData.winwork_stage;
				wowChanges.ways_of_winning = {};

				//checklist
				var checklist = [];
				for (var i = 0; i < winChecklist.length; i++) {
					if (index == i) {
						winChecklist[index].status = (field == 'checklist') ? e.checked : winChecklist[index].status
					}
					checklist.push(winChecklist[i]);
				}
				wowChanges.ways_of_winning.checklist = checklist;

				//responsibility
				var responsibility = [];
				for (var i = 0; i < winTools.length; i++) {
					if (index == i) {
						winTools[index].status = (field == 'resp') ? e.checked : winTools[index].status
					}
					responsibility.push(winTools[i]);
				}
				wowChanges.ways_of_winning.responsibility = responsibility;

				//reference
				var reference = [];
				for (var i = 0; i < opportunityData.ways_winning.completed_list.length; i++) {
					reference.push(opportunityData.ways_winning.completed_list[i]);
				}
				wowChanges.ways_of_winning.reference = reference;
				wowChanges.bid_team_role = findUserBidRole?.bid_team_role;

				var res = await saveBidteam(role, wowChanges)
				winningLoad(opportunityData)
			}
		} catch (error) {
			// Handle any errors that occurred during the API calls
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or contact Admin.'
			});
		}
	}

	const statusTemplate = (rowData, ind) => {
		return (
			<CheckboxElement
				id={`check-${ind.rowIndex}`}
				name={`check-${ind.rowIndex}`}
				value={rowData.status}
				checked={rowData.status}
				onChangeCheck={(e) => wow_check_change(e, ind.rowIndex, 'checklist')}
				className="mr-2"
				disabled={isStop}
			/>
		)
	}

	const statusRespTemplate = (rowData, ind) => {
		return (
			<CheckboxElement
				id={`resp-${ind.rowIndex}`}
				name={`resp-${ind.rowIndex}`}
				value={rowData.status}
				checked={rowData.status}
				onChangeCheck={(e) => wow_check_change(e, ind.rowIndex, 'resp')}
				className="mr-2"
				disabled={isStop}
			/>
		)
	}

	const checkTemplate = (rowData) => {
		return (
			<a target="_blank" href={`${rowData.url}`}>{rowData.check}</a>
		)
	}

	const columns1 = [
		{ field: "check", header: _.find(props.fieldData.oppWaysOfWinningTable, { table_name: "Positioning to win checklist for the current stages" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '80%' } },
		{ field: "status", header: "", body: statusTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '20%' } },
	]

	const columns2 = [
		{ field: "check", header: _.find(props.fieldData.oppWaysOfWinningTable, { table_name: "My Responsibilities for this Stage" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '80%' } },
		{ field: "status", header: "", body: statusRespTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '20%' } },
	]

	const columns3 = [
		{ field: "check", header: _.find(props.fieldData.oppWaysOfWinningTable, { table_name: "Ways of Winning Prompts" })?.display_name, body: checkTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '80%' } },
	]

	const [optionDocument, setOptionDocument] = useState([
		{ id: "", location: "", reference: "" },
	]);

	const onTextChangeDocumentName = (index, field) => (e) => {
		const newDocumentName = [...opportunityData?.ways_winning.completed_list];
		if (field === "reference") {
			newDocumentName[index][field] = e.target.value;
		} else {
			newDocumentName[index][field] = e.target.value;
		}

		setOpportunityData((prevState) => ({
			...prevState,
			ways_winning: {
				...prevState.ways_winning,
				completed_list: newDocumentName, // Directly set the updated array here
			},
		}));
	};

	const documentReferenceNameEditor = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElementElement
					className="dropdown-field-handle"
					value={row.reference}
					placeholder="Description"
					onChange={onTextChangeDocumentName(index?.rowIndex, "reference")}
				/>
			</div>
		);
	};

	const documentReferenceLocationEditor = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElementElement
					className="dropdown-field-handle"
					value={row.location}
					placeholder="Description"
					onChange={onTextChangeDocumentName(index?.rowIndex, "location")}
				/>
			</div>
		);
	};

	const columns = [
		{ field: "reference", header: _.find(props.fieldData.oppWaysOfWinningHeaders, { header_name: "Name" })?.display_name, body: documentReferenceNameEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '30%' } },
		{ field: "location", header: _.find(props.fieldData.oppWaysOfWinningHeaders, { header_name: "Location Reference" })?.display_name, body: documentReferenceLocationEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '70%' } },
	]

	const rowClick = async (data) => {
		setSelectedOption(data)
	};

	const generateRandomID = () => {
		const hexChars = '0123456789abcdef';
		let result = '';
		for (let i = 0; i < 24; i++) {
			result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
		}
		return result;
	}

	const addItemDocument = () => {
		const newRow = {
			_id: generateRandomID(),
			reference: "",
			location: ""

		};
		setOptionDocument([...optionDocument, newRow]);
		setOpportunityData((prevState) => ({
			...prevState,
			['ways_winning']: {
				...prevState['ways_winning'],
				['completed_list']: [
					...prevState['ways_winning']['completed_list'],
					newRow
				],
			},
		}));
	};

	const handleDeleteDocument = () => {
		const updatedOptions = opportunityData.ways_winning.completed_list.filter(
			(row) => !selectedOption.includes(row)
		);
		setOptionDocument(updatedOptions);
		setOpportunityData((prevState) => ({
			...prevState,
			ways_winning: {
				...prevState.ways_winning,
				completed_list: updatedOptions, // Replace completed_list with updatedOptions
			},
		}));
		setSelectedOption([]);
	};

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			{
				<form className='grid-container'>
					{
						Object.entries(newModule)?.map(([key, value]) => (
							<div key={key} className='mt-10'>
								<Accordion activeIndex={0}>
									{
										<AccordionTab header={value} disabled>
											{
												key == 'obj1' &&
												<div className='new-field'>
													{
														_.find(props.fieldData.oppWaysOfWinningTable, { table_name: "Positioning to win checklist for the current stages" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<DataTable
																	value={winChecklist.length > 0 ? winChecklist : []}
																	columns={columns1}
																	dataKey="_id"
																	isNewField={true}
																/>
															</div>
														</div>
													}
												</div>
											}
											{
												key == 'obj2' &&
												<div className="new-field">
													{
														_.find(props.fieldData.oppWaysOfWinningTable, { table_name: "My Responsibilities for this Stage" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<DataTable
																	value={winTools.length > 0 ? winTools : []}
																	columns={columns2}
																	dataKey="_id"
																	isNewField={true}
																/>
															</div>
														</div>
													}
												</div>
											}
											{
												key == 'obj3' &&
												<div className="new-field">
													{
														_.find(props.fieldData.oppWaysOfWinningTable, { table_name: "Ways of Winning Prompts" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<DataTable
																	value={winTools.length > 0 ? winTools : []}
																	columns={columns3}
																	dataKey="_id"
																	isNewField={true}
																/>
															</div>
														</div>
													}
												</div>
											}
											{
												key == 'obj4' &&
												<div className="new-field">
													{
														_.find(props.fieldData.oppWaysOfWinningTable, { table_name: "Completed List" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<div className="form-group row align-items-center mb-0">
																	<div className="col-md-6 pl-0">
																		<p className="label-text">
																			{_.find(props.fieldData.oppWaysOfWinningTable, { table_name: "Completed List" })?.display_name}
																		</p>
																	</div>
																	<div className="col pr-0 d-flex justify-end">
																		<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteDocument} />
																		<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemDocument} />
																	</div>
																</div>
																<DataTable
																	value={opportunityData.ways_winning?.completed_list.length > 0 ? opportunityData.ways_winning?.completed_list : []}
																	columns={columns}
																	dataKey="_id"
																	isNotReorder={true}
																	rowClick={rowClick}
																/>
															</div>
														</div>
													}
												</div>
											}
										</AccordionTab>
									}
								</Accordion>
							</div>
						)
						)
					}
				</form>
			}
		</div>
	)
}

export default PromptsAndChecklists